import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { getProject } from "@/lib/api/project";
import { listPhases } from "@/lib/api/phases";
import type { Tables } from "@/types/database";
import { throwIfError } from "./_supabaseErrors";

export type Phase = Tables<"phases">;
export type Task = Tables<"tasks">;

export type SchedulePayload = {
  phases: Phase[];
  tasks: Task[];
};

export async function getSchedulePayload(projectId?: string | null): Promise<SchedulePayload> {
  const project = await getProject();
  const pid = projectId ?? project?.id ?? undefined;
  const phases = await listPhases(pid);
  let tasks: Task[] = [];
  if (phases.length > 0) {
    const phaseIds = phases.map((p) => p.id);
    const { data, error } = await supabase
      .from("tasks")
      .select("*")
      .in("phase_id", phaseIds)
      .order("order_index", { ascending: true });
    throwIfError(error);
    tasks = data ?? [];
  }
  return { phases, tasks };
}

export const scheduleQueryOptions = (projectId?: string | null) =>
  queryOptions({
    queryKey: ["schedule", { projectId: projectId ?? "default" }] as const,
    queryFn: () => getSchedulePayload(projectId)
  });
